import { Box } from '@mui/material';
import React from 'react';

// Responsive grid wrapper for related fields.  Default: one column
// on mobile, two on >=sm.  Override with the `columns` prop if a
// section needs a different layout.
export default function SettingsFieldGroup({ columns = { xs: 1, sm: 2 }, gap = 2, children, sx }) {
  const gridTemplateColumns = Object.fromEntries(
    Object.entries(columns).map(([breakpoint, count]) => [breakpoint, `repeat(${count}, 1fr)`]),
  );
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns,
        gap,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
